const isText = (card: CanvasCard.Card): card is CanvasCard.TextCard =>
  card.content.type === 'Text';

export default isText;
